import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ProductContents() {
  return <section className="py-12 md:py-20 px-4 md:px-6 bg-[var(--bg-surface)]" data-id="element-234">
      <div className="max-w-[800px] mx-auto" data-id="element-235">
        <div className="text-center mb-10 md:mb-14" data-id="element-236">
          <p className="text-[var(--accent)] uppercase tracking-widest text-sm font-bold mb-3" data-id="element-237">
            The Complete System
          </p>
          <h2 className="text-2xl md:text-4xl font-serif text-[var(--text-heading)] mb-4" data-id="element-238">
            Everything you need for Sensory Victory
          </h2>
          <p className="text-base md:text-lg text-[var(--text-primary)] max-w-2xl mx-auto" data-id="element-239">
            If you were to see a specialist for these resources, you’d pay $200+
            per hour. Today, you get the entire system for a fraction of that.
          </p>
        </div>

        <div className="bg-[var(--bg-card)] rounded-2xl border border-[var(--accent)]/20 shadow-lg overflow-hidden flex flex-col md:flex-row" data-id="element-240">
          <div className="bg-[var(--bg-elevated)] p-8 md:w-2/5 flex items-center justify-center border-b md:border-b-0 md:border-r border-[var(--border-subtle)]" data-id="element-241">
            <img src="https://cdn.magicpatterns.com/uploads/xdkdFJBsvzWQikawQ8nDi2/heylloyd-image-1772934658127.png" alt="Sensory Feeding Victory Ebook" className="w-48 md:w-full max-w-[240px] rounded-lg shadow-md" data-id="element-242" />
          </div>

          <div className="p-8 md:w-3/5 flex flex-col justify-center" data-id="element-243">
            <div className="inline-block bg-[var(--accent-soft)] text-[var(--accent)] text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider mb-4 w-max" data-id="element-244">
              Main Guide
            </div>
            <h3 className="text-2xl font-serif font-bold text-[var(--text-heading)] mb-2" data-id="element-245">
              Sensory Feeding Victory
            </h3>
            <p className="text-[var(--text-muted)] text-sm mb-6" data-id="element-246">
              The complete Texture Hacking blueprint.
            </p>

            <ul className="space-y-4 mb-6" data-id="element-247">
              <li className="flex items-start gap-3 text-[var(--text-primary)]" data-id="element-248">
                <CheckCircle2 className="w-5 h-5 text-[var(--accent)] flex-shrink-0 mt-0.5" data-id="element-249" />
                <span data-id="element-250">
                  Step-by-step protocols to introduce new foods without
                  pressure.
                </span>
              </li>
              <li className="flex items-start gap-3 text-[var(--text-primary)]" data-id="element-251">
                <CheckCircle2 className="w-5 h-5 text-[var(--accent)] flex-shrink-0 mt-0.5" data-id="element-252" />
                <span data-id="element-253">The science of "Micro-Shifts" explained simply.</span>
              </li>
              <li className="flex items-start gap-3 text-[var(--text-primary)]" data-id="element-254">
                <CheckCircle2 className="w-5 h-5 text-[var(--accent)] flex-shrink-0 mt-0.5" data-id="element-255" />
                <span data-id="element-256">
                  How to identify and expand from your child's current Safe
                  Foods.
                </span>
              </li>
            </ul>

            <div className="mt-auto pt-6 border-t border-[var(--border-subtle)]" data-id="element-257">
              <p className="text-[var(--text-muted)] text-sm" data-id="element-258">
                Standalone Value: <span className="line-through" data-id="element-259">$47</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}